<template>
  <div class="sliders">
    <div class="slidertext">{{ question.text }}<b-button v-b-modal="'modal-center' + question.id" class="button2"><img src="@/assets/knapp.png"></b-button>
      <div class="pop">
        <b-modal :id="'modal-center' + question.id" centered title hide-footer>
          <p class="modalheader">{{question.text}}</p>
          <p class="modaltext">{{ question.entry }}</p>
        </b-modal>
      </div>
    </div>
    <vue-slider
      ref="slider"
      v-model="value"
      :marks="marks"
      :included="true"
      @change="onChange($event)"
    ></vue-slider>
    <br>
    <br>
  </div>
</template>

<script>
// https://github.com/NightCatSama/vue-slider-component
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  props: ["sectionId", "question"],
  components: {
    VueSlider
  },
  data () {
    return {
      value: 0,
      marks: {},
      sliderTexts: {
        0: ["Ingen", "", "Kort", "", "Medel", "", "Lång"],
        1: ["Ingen erfarenhet", "", "Viss erfarenhet", "", "Omfattande erfarenhet"],
        2: [ "Litet intresse", "", "Visst intresse", "", "Stort intresse" ]
      }
    };
  },
  methods: {
    onChange (value) {
      this.$store.dispatch("updateAnswer", {
        sectionId: this.sectionId,
        questionId: this.question.id,
        sliderValue: this.value,
        answer: this.marks[value].originalValue
      });
    },
    createOptions () {
      // Calculates values for the slider and the selected value
      var totalValue = 100;
      var totalPoints = this.question.point;
      var totalTexts = this.sliderTexts[this.question.id].length - 1;

      var sliderValue = totalValue / totalTexts;
      var originalSliderValue = totalPoints / totalTexts;

      this.sliderTexts[this.question.id].forEach((text, index) => {
        var value = index * sliderValue;

        var originalValue = index * originalSliderValue;

        this.marks[value] = {
          label: text,
          originalValue: originalValue
        };
      });
    },
    getData () {
      this.marks = {};
      this.value = 0;
      this.createOptions();
    }
  },
  watch: {
    $route: "getData"
  },
  created () {
    var state = this.$store.state;

    // Set previous value if there is any when the component is loaded
    if (state && state.answers[this.sectionId] && state.answers[this.sectionId][this.question.id]) {
      var item = this.$store.state.answers[this.sectionId][this.question.id];
      this.value = item.sliderValue;
    }
    this.createOptions();
  }
};
</script>
<style scoped lang="scss">
.sliders {
  padding-left: 30px;
  padding-right: 30px;
}

.slidertext {
  font-family: "museo-slab";
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.79;
  letter-spacing: normal;
  color: #43474b;
  white-space: pre-wrap;
}

img {
  height: 25px;
  margin: -8px 0px 0px -10px;
}

.button2 {
  height: 30px;
  width: 20px;
  background-color: transparent !important;
  box-shadow: none !important;
  border-color: transparent;
  border: none;
}

.pop {
  background-color: #f0ece6;
  .modaltext {
    font-family: "museo-sans";
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #43474b;
    @media (max-width: 991px) {
      font-family: "museo-sans";
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #43474b;
    }
  }
}
.modalheader {
  font-family: "museo-slab";
  font-size: 30px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #2c302e;
  @media (max-width: 991px) {
    font-family: "museo-slab";
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: center;
    color: #2c302e;
  }
}
.vue-slider-ltr .vue-slider-mark {
  height: 25px;
  width: 1px;
}
</style>
<style>
.modal-content {
  background-color: #f0ece6 !important;
  margin: 0 auto;
  border: 10px solid #fff !important;
  width: 480px !important;
  border-radius: 0 !important;
}
.modal-header {
  border-bottom: none !important;
}
.modal-body {
  margin-top: -30px;
}
.modal-header .close {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0px 5px 0px 5px !important;
  padding: 0 !important;
  z-index: 10;
}
.vue-slider-ltr .vue-slider-mark {
  height: 25px !important;
  width: 1px !important;
}
.vue-slider-mark:first-child .vue-slider-mark-step,
.vue-slider-mark:last-child .vue-slider-mark-step {
  display: block;
}
.vue-slider-rail {
  background-color: #cccccc8a;
}
.vue-slider-dot-tooltip-show {
  visibility: hidden!important;
}
</style>
